import React from 'react';
import { useDispatch } from 'react-redux';

// Utils
import { getElementId, getMediaType } from '../../../../../../common/elements/utils/elementPropertyUtils';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';
import { isEmpty } from '../../../../../../common/utils/immutableHelper';

// Actions
import { navigateToElement } from '../../../../../reducers/navigationActions';
import { deselectAllElements } from '../../../../../element/selection/selectionActions';

// Components
import ToolbarTool from '../../ToolbarTool';
import { ToolProps } from '../../Tool';
import Icon from '../../../../../components/icons/Icon';

// Constants
import { MEDIA_TYPES } from '../../../../../../common/links/richMediaConstants';

export type ImageModalToolMode = 'edit' | 'background';

const IMAGE_MODAL_TOOL_CONFIG: Record<
    ImageModalToolMode,
    {
        iconName: string;
        routeParam: 'editing' | 'editing-background';
    }
> = {
    edit: {
        iconName: 'toolbar-image-edit',
        routeParam: 'editing',
    },
    background: {
        iconName: 'toolbar-image-background',
        routeParam: 'editing-background',
    },
};

type ImageModalToolProps = Omit<ToolProps, 'children' | 'iconName' | 'isActive' | 'onClick'> & {
    mode: ImageModalToolMode;
    selectedElements?: Immutable.List<ImMNElement>;
};

/**
 * Opens an image modal editing mode for the selected image.
 */
const ImageModalTool: React.FC<ImageModalToolProps> = (props) => {
    const { mode, selectedElements, name, ...toolProps } = props;
    const dispatch = useDispatch();

    if (!selectedElements || isEmpty(selectedElements)) return null;

    const selectedElement = selectedElements.first();

    if (getMediaType(selectedElement) === MEDIA_TYPES.NO_MEDIA) return null;

    const { iconName, routeParam } = IMAGE_MODAL_TOOL_CONFIG[mode];

    const onClick = () => {
        const elementId = getElementId(selectedElement);

        dispatch(deselectAllElements());

        dispatch(
            navigateToElement({
                elementId,
                params: { [routeParam]: true },
            }),
        );
    };

    return (
        <ToolbarTool {...toolProps} onClick={onClick} name={name} isActive={false}>
            <Icon name={iconName} />
        </ToolbarTool>
    );
};

export default ImageModalTool;
